import { useTw } from '../Styles'
import { DetailedHTMLProps, SelectHTMLAttributes } from 'react'
import { formSelect } from '@twind/forms'

export function Select(
  props: DetailedHTMLProps<
    SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  >
) {
  const tw = useTw()
  return (
    <select
      {...props}
      className={tw`${formSelect} rounded-md block w-full sm:text-sm border-neutral-300`}
    >
      {props.value === undefined ? <option>{props.placeholder}</option> : null}
      {props.children}
    </select>
  )
}
